import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled.section.attrs(() => ({
    className: "container",
}))`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]}px;
    padding-top: ${theme.space[4]}px;
`;

export const Header = styled.header`
    display: flex;
    gap: ${theme.space[3]}px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    margin-top: ${theme.space[4]}px;

    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;
        gap: normal;
        align-items: center;
    }

    @media ${getBreakpoint("up", "xl")} {
        margin-top: ${theme.space[5]}px;
        margin-bottom: ${theme.space[1]}px;
    }
`;

export const Title = styled.h1.attrs(() => ({
    className: "gamma-text",
}))`
    margin-bottom: 0 !important; /* Override parent CSS */
    padding: 0;
    color: ${theme.colors.highlightBlack};
`;
